import { NavLink, Outlet, useLocation } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { logout } from '../features/auth/authSlice';

export default function SupportShell() {
  const dispatch = useAppDispatch();
  const user = useAppSelector((s) => s.auth.user);
  const env = useAppSelector((s) => s.app.env);
  const location = useLocation();
  const smith = location.pathname.startsWith('/smith');

  return (
    <div className="min-h-screen bg-[#fffafc]">
      <header className="sticky top-0 z-20 border-b border-[#fce7f3] bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-3">
          <div className="flex items-center gap-6">
            <NavLink to="/" className="flex items-center gap-2.5">
              <BrandLogo size={30} />
              <span className="text-base font-black tracking-tight text-[#6b0030]">Micus Support</span>
            </NavLink>
            <nav className="flex gap-1">
              <NavLink
                to="/"
                end
                className={({ isActive }) => `rounded-full px-3 py-1.5 text-xs font-bold ${isActive ? 'bg-[#d6006e] text-white' : 'text-[#6b0030] hover:bg-[#fdf2f8]'}`}
              >
                AI monitor
              </NavLink>
              <NavLink
                to="/smith"
                className={({ isActive }) => `rounded-full px-3 py-1.5 text-xs font-bold ${isActive ? 'bg-[#d6006e] text-white' : 'text-[#6b0030] hover:bg-[#fdf2f8]'}`}
                data-testid="nav-smith"
              >
                Smith
              </NavLink>
              <NavLink
                to="/prompts"
                className={({ isActive }) => `rounded-full px-3 py-1.5 text-xs font-bold ${isActive ? 'bg-[#d6006e] text-white' : 'text-[#6b0030] hover:bg-[#fdf2f8]'}`}
              >
                Prompt versions
              </NavLink>
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-[10px] font-bold uppercase tracking-wider text-[#c084a0] sm:inline">{env}</span>
            <span className="text-xs font-semibold text-[#9d0050]">{user?.name || user?.email}</span>
            <button type="button" onClick={() => dispatch(logout())} className="rounded-lg px-2.5 py-1 text-xs font-bold text-[#d6006e] hover:bg-[#fdf2f8]">
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className={`mx-auto px-6 py-8 ${smith ? 'max-w-[1180px]' : 'max-w-7xl'}`}>
        <Outlet />
      </main>
    </div>
  );
}
